export const DEDUCTION_PRORITY = "DEDUCTIONS_PRIORITY";
export const THIRD_PARTY = "THIRD_PARTY";
export const TAX_AND_CODES = "TAX_AND_CODES";
export const MAP_GL = "MAP_GL";
export const EARNINGS_GROUPS = "EARNINGS_GROUPS";
export const EARNINGS = "EARNINGS";
export const DEDUCTIONS = "DEDUCTIONS";
export const WORKERS_COMP = "WORKERS_COMP";
